module.exports = __webpack_public_path__ + "static/media/playertable icon-2.ab42d6b8.svg";